import React, { useState } from "react";
import styled from "styled-components";

import { Box, numberToCurrency } from "vqp-common";
import { Table, Loading, Button, CSVButton } from "../common";

import { OrderDetailModal } from "./details/orderDetails";
import { Box as MaterialBox } from "@material-ui/core";
import { OrderDetailsStatus } from "./details/status/orderDetailsStatus";
import ReactTooltip from "react-tooltip";
import {
  Star as StarIcon,
  StarBorder as StarBorderIcon,
} from "@material-ui/icons";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px;
`;

const Card = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Title = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.textBold};
`;

const CSVWrapper = styled.div`
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
`;

const DetailButton = styled(Button)`
  font-size: 10px !important;
`;

const RatingBox = styled.div`
  color: #d8b462;
  & svg {
    color: #d8b462;
    font-size: 16px;
  }
`;

const makeCSVHeaders = (columns) =>
  columns.map((col) => ({
    label: col.Header,
    key: col.accessor,
  }));

export const OrdersList = ({ orders }) => {
  const [orderId, setOrderId] = useState(null);

  const handleOpenDetailModal = (value) => {
    setOrderId(value);
  };

  const getColumnDataById = (id) => {
    return orders.find((order) => order.id === id);
  };

  const makeColumns = () => {
    return [
      {
        Header: "Pedido",
        accessor: "id",
        minWidth: 75,
        Cell: (props) => {
          const order = getColumnDataById(props.value);
          return (
            <MaterialBox>
              <div>#{props.value}</div>
              <div>
                <b>{order?.modality}</b>
              </div>
            </MaterialBox>
          );
        },
      },
      {
        Header: "Status do pedido",
        accessor: "status",
        headerStyle: { display: "flex", justifyContent: "center" },
        minWidth: 175,
        Cell: (props) => {
          const order = getColumnDataById(props.original.id);
          const id = Math.random().toString();
          return (
            <MaterialBox>
              <div data-tip="" data-for={id}>
                <OrderDetailsStatus
                  status={props.value}
                  style={{ width: "119px", margin: "8px 0" }}
                >
                  {props.value}
                </OrderDetailsStatus>
              </div>

              {order?.deliveryForecast && (
                <ReactTooltip id={id} place="bottom">
                  <MaterialBox
                    style={{
                      fontSize: 11,
                      textAlign: "center",
                      lineHeight: "13px",
                      marginTop: "4px",
                    }}
                  >
                    Previsão de entrega: <br />
                    {order.deliveryForecast}
                  </MaterialBox>
                </ReactTooltip>
              )}
            </MaterialBox>
          );
        },
      },
      {
        Header: "Data",
        accessor: "date",
        minWidth: 150,
      },
      {
        Header: "Usuário",
        accessor: "client",
        minWidth: 150,
      },
      {
        Header: "Valor",
        accessor: "value",
        Cell: (props) => numberToCurrency(props.value),
        minWidth: 120,
      },
      {
        Header: "Cupom",
        accessor: "cupom",
        Cell: (props) =>
          props.value === 0 ? "-" : numberToCurrency(props.value),
        minWidth: 120,
      },
      {
        Header: "Forma de pgto.",
        accessor: "paymentMethod",
        minWidth: 150,
      },
      {
        Header: "Agendamento",
        accessor: "scheduleDate",
        minWidth: 250,
        Cell: ({ value }) => {
          return value ? value : "-";
        },
      },
      {
        Header: "Avaliação",
        accessor: "rating",
        minWidth: 150,
        Cell: ({ value }) => {
          return !value ? (
            <i>Sem avaliação</i>
          ) : (
            <RatingBox>
              ({value})
              {[...Array(5).keys()].map((num, key) => {
                if (num < value) {
                  return <StarIcon key={key} />;
                }
                return <StarBorderIcon key={key} />;
              })}
            </RatingBox>
          );
        },
      },
      {
        Header: "",
        accessor: "id",
        minWidth: 130,
        Cell: (props) => (
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            style={{ width: "100%" }}
          >
            <DetailButton
              className="success"
              width={"120px"}
              onClick={() => handleOpenDetailModal(props.value)}
            >
              VER DETALHES
            </DetailButton>
          </MaterialBox>
        ),
      },
    ];
  };

  const columns = makeColumns();

  if (!orders) {
    return <Loading />;
  }

  return (
    <Wrapper>
      <Title>Pedidos</Title>
      <Card>
        <Table
          className="-striped"
          data={orders}
          columns={columns}
          noDataText="Sem pedidos nesse período."
          getTdProps={() => ({
            style: {
              alignSelf: "center",
            },
          })}
        />
        <CSVWrapper>
          <CSVButton
            headers={makeCSVHeaders(columns)}
            data={orders}
            title="Pedidos"
          />
        </CSVWrapper>
      </Card>

      {!!orderId && (
        <OrderDetailModal
          orderId={orderId}
          isOpen={!!orderId}
          onClose={() => setOrderId(undefined)}
        />
      )}
    </Wrapper>
  );
};
